import { isRouteErrorResponse } from 'react-router-dom'
import type { Messages } from '@/i18n/index.ts'

/**
 * One line for "Details for support" under a page that failed (D-66).
 *
 * The message only, never the stack: it is what someone reads out or pastes to an administrator,
 * and a stack would say nothing to them while showing file paths to everyone.
 *
 * `t` is a parameter rather than an import, and it is the narrowest slice that carries the one
 * sentence this module can produce on its own (PRD-27 LOC-012). A pure module cannot call
 * `useI18n()`, and reaching into a catalogue at module scope would freeze the language at import
 * with nothing to show for it — the exact failure F-3 records. The two other branches return the
 * runtime's own words, which are already in the reader's language and are not ours to restate.
 */
export const describeRouteError = (t: Pick<Messages, 'shell'>, error: unknown): string => {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`.trim()
  if (error instanceof Error) return error.message || error.name
  if (typeof error === 'string' && error !== '') return error
  return t.shell.routeError.unknown
}
